const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccounting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 480 480",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m184 288c-44.183594 0-80 35.816406-80 80s35.816406 80 80 80 80-35.816406 80-80c-.046875-44.164062-35.835938-79.953125-80-80zm0 144c-35.347656 0-64-28.652344-64-64s28.652344-64 64-64 64 28.652344 64 64c-.039062 35.328125-28.671875 63.960938-64 64zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m184 344c9.769531 0 16 4.734375 16 8h16c0-11.367188-10.070312-20.574219-24-23.199219v-8.800781h-16v8.800781c-13.929688 2.605469-24 11.816407-24 23.199219 0 13.464844 14.054688 24 32 24 9.769531 0 16 4.734375 16 8s-6.230469 8-16 8-16-4.734375-16-8h-16c0 11.367188 10.070312 20.574219 24 23.199219v8.800781h16v-8.800781c13.929688-2.605469 24-11.816407 24-23.199219 0-13.464844-14.054688-24-32-24-9.769531 0-16-4.734375-16-8s6.230469-8 16-8zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m408 464h-336v-192h128c13.253906 0 24-10.746094 24-24v-200h88v96h96v112h16v-123.3125l-100.6875-100.6875h-99.3125v-8c0-13.253906-10.746094-24-24-24h-176c-13.253906 0-24 10.746094-24 24v224c0 13.253906 10.746094 24 24 24h32v208h368v-112h-16zm-80-404.6875 68.6875 68.6875h-68.6875zm-312 188.6875v-224c0-4.417969 3.582031-8 8-8h176c4.417969 0 8 3.582031 8 8v224c0 4.417969-3.582031 8-8 8h-176c-4.417969 0-8-3.582031-8-8zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m256 200h16v16h-16zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m288 200h96v16h-96zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m256 168h16v16h-16zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m288 168h96v16h-96zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m256 232h16v16h-16zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m288 232h96v16h-96zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m256 264h16v16h-16zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m288 264h96v16h-96zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m200 24h-176v56h176zm-16 40h-144v-24h144zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m64 88h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m120 88h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m176 88h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m64 144h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m120 144h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m176 144h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m64 200h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m120 200h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m176 200h-16c-8.835938 0-16 7.164062-16 16v16c0 8.835938 7.164062 16 16 16h16c8.835938 0 16-7.164062 16-16v-16c0-8.835938-7.164062-16-16-16zm-16 32v-16h16v16zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "m472.734375 255.265625c-9.496094-9.066406-24.4375-9.066406-33.933594 0l-137.144531 137.140625c-.664062.671875-1.207031 1.453125-1.601562 2.3125l-19.3125 41.9375c-1.394532 3.039062-.75 6.628906 1.617187 8.992188 2.363281 2.367187 5.953125 3.011718 8.992187 1.617187l41.9375-19.3125c.859376-.394531 1.640626-.933594 2.3125-1.601563l137.132813-137.144531c9.375-9.371093 9.375-24.570312 0-33.941406zm-147.445313 158.75-20.960937 9.65625 9.65625-20.960937 102.253906-102.261719 11.3125 11.3125zm113.597657-113.601563-11.3125-11.308593 5.601562-5.601563 11.3125 11.3125zm22.5625-22.558593-5.65625 5.65625-11.3125-11.3125 5.664062-5.65625c3.160157-3.023438 8.140625-3.023438 11.304688 0 3.121093 3.125 3.121093 8.1875 0 11.3125zm0 0",
    fill: "#528aea",
    "data-original": "#000000",
    style: {},
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccounting);
export default __webpack_public_path__ + "static/media/accounting.2247f8fb92e5c6850f9db1da2f4ef10b.svg";
export { ForwardRef as ReactComponent };